import { createSlice } from "@reduxjs/toolkit";
import {
  emailGetConfig, emailSaveConfig, emailSendTest,
  emailListEvents, emailStats,
} from "../actions/email-system-actions";

const initialState = {
  config: null,
  events: [],
  stats: null,
  loading: {},
  error: null,
  testResult: null,
};

const slice = createSlice({
  name: "emailSystem",
  initialState,
  reducers: {
    clearTestResult: (s) => { s.testResult = null; },
  },
  extraReducers: (b) => {
    b.addCase(emailGetConfig.pending, (s) => { s.loading.config = true; })
     .addCase(emailGetConfig.fulfilled, (s, a) => { s.loading.config = false; s.config = a.payload; })
     .addCase(emailGetConfig.rejected, (s, a) => { s.loading.config = false; s.error = a.payload; })
     .addCase(emailSaveConfig.fulfilled, (s, a) => { s.config = a.payload; })
     .addCase(emailSendTest.fulfilled, (s, a) => { s.testResult = a.payload; })
     .addCase(emailListEvents.fulfilled, (s, a) => { s.events = a.payload || []; })
     .addCase(emailStats.fulfilled, (s, a) => { s.stats = a.payload; });
  },
});

export const { clearTestResult } = slice.actions;
const emailSystemSliceReducer = slice.reducer;
export default emailSystemSliceReducer;
